export default class Show {
    constructor(main) {
        this.main = main;
        this.options = { rootMargin: '0px 0px -20%' };

        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        this.$showArr = [...document.querySelectorAll('.js-show')];
    }

    execLoop() {
        this.$showArr.forEach(($show) => this._setObserve($show));
    }

    _setObserve($show) {
        const setEntries = (entries) =>
            entries.forEach((entry) => {
                if (entry.isIntersecting && !entry.target.classList.contains('-active')) {
                    this._addClass(entry);
                } else {
                    if (window.location.hash) {
                        const targetId = window.location.hash.substring(1);
                        const targetElement = document.getElementById(targetId);

                        if (targetElement) {
                            this._addClass(entry);
                        }
                    }
                }
            });

        UTILS.observeIntersection($show, setEntries, this.options);
    }

    _addClass(entry) {
        entry.target.classList.add('-active');
        entry.target.classList.contains('js-page-ttl') && this.main.pageTtl.execLoop(entry);
    }
}
